export const COMPACT_LAYOUT_UPDATED = 'octopus:compact-layout-updated'

declare global {
  interface WindowEventMap {
    'octopus:compact-layout-updated': Event
  }
}
